module.exports = __webpack_public_path__ + "img/logo.712fa5e1.svg";